import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { productPriceClick } from '../../../product/actions/product';
import { Offer, Price } from '../../../../types';
import HighlightedSearchResult from '../products/highlighted-search-result';
import { ProductGridCard } from 'src/components/product-card-new';

type Props = {
  offer: Offer;
  onClick?: (offer: Offer) => void;
};
const OfferWrapper = ({ offer, onClick }: Props) => {
  const dispatch = useDispatch();
  const price = offer.offerPrice && offer.offerPrice.regular;
  const onClickHandler = useCallback(() => {
    if (typeof onClick === 'function') {
      onClick(offer);
    }
    // Dummy Price object need here for the clickout event (only the type is needed)
    const clickoutPrice: Price = {
      type: '',
      authorizedDealer: false,
    };
    dispatch(
      productPriceClick(null, clickoutPrice, !!offer.store.featured, 'raw')
    );
  }, [offer, dispatch, onClick]);

  return (
    <ProductGridCard
      type="offer"
      name={offer.name}
      highlightedName={
        offer.highlight ? (
          <HighlightedSearchResult>{offer.highlight}</HighlightedSearchResult>
        ) : (
          undefined
        )
      }
      imageSrc={offer.media.first || ''}
      shouldLazyLoadImage
      price={price}
      store={offer.store}
      link={offer.externalUri}
      onClick={onClickHandler}
    />
  );
};

export default OfferWrapper;
